import React from "react";
import { MDBBtn, MDBIcon } from "mdb-react-ui-kit";
import { doFetch } from "Projects/CC_cubi_clan_project/Utils/ConnectionManager";
import { toast } from "Projects/CC_cubi_clan_project/GlobalComponents/ToastHost/ToastHost";
import RichTextEditor from "Projects/CC_cubi_clan_project/GlobalComponents/RichTextEditor/RichTextEditor";
import "./AdminAdnSection.css";

/**
 * AdminAdnSection – Vista admin para editar el contenido de "El Camino del Hapkido".
 * Usa el RichTextEditor y persiste en la tabla genérica site_content
 * con clave CAMINO_HAPKIDO.
 */
class AdminAdnSection extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      contentId: null,
      contentHtml: "",
      originalHtml: "",
      loaded: false,
      saving: false,
    };
  }

  componentDidMount() {
    this.loadContent();
  }

  loadContent() {
    if (this.props.onLoading) this.props.onLoading(true);

    doFetch("MUGIN", "getSiteContent?key=CAMINO_HAPKIDO")
      .then((res) => res.json())
      .then((json) => {
        if (json.STATE === "SUCCESS" && json.DATA) {
          const html = json.DATA.contentValue || "";
          this.setState({
            contentId: json.DATA.IDContent,
            contentHtml: html,
            originalHtml: html,
            loaded: true,
          });
        } else {
          this.setState({ loaded: true });
        }
      })
      .catch((err) => {
        console.error("Error loading ADN content:", err);
        toast.show({ message: "Error al cargar contenido", type: "danger" });
        this.setState({ loaded: true });
      })
      .finally(() => {
        if (this.props.onLoading) this.props.onLoading(false);
      });
  }

  saveContent = () => {
    const { contentId, contentHtml } = this.state;

    this.setState({ saving: true });
    if (this.props.onLoading) this.props.onLoading(true);

    const body = {
      contentKey: "CAMINO_HAPKIDO",
      contentValue: contentHtml,
      contentType: "html",
    };
    if (contentId) body.IDContent = contentId;

    doFetch("MUGIN", "upsertSiteContent", {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
    })
      .then((res) => res.json())
      .then((json) => {
        if (json.STATE === "SUCCESS") {
          toast.show({
            message: "Contenido ADN guardado correctamente",
            type: "success",
            position: "bottom-center",
            timeout: 3000,
          });
          if (json.DATA) {
            this.setState({
              contentId: json.DATA.IDContent,
              originalHtml: this.state.contentHtml,
            });
          }
        } else {
          toast.show({ message: json.MESSAGE || "Error al guardar", type: "danger" });
        }
      })
      .catch((err) => {
        console.error("Error saving ADN content:", err);
        toast.show({ message: "Error de conexión al guardar", type: "danger" });
      })
      .finally(() => {
        this.setState({ saving: false });
        if (this.props.onLoading) this.props.onLoading(false);
      });
  };

  render() {
    const { contentHtml, loaded, saving, originalHtml } = this.state;
    const hasChanges = contentHtml !== originalHtml;

    if (!loaded) return null;

    return (
      <div className="admin-adn-section">
        <div className="admin-adn-header">
          <h2 className="admin-adn-title">
            <MDBIcon fas icon="pen" className="me-2" />
            Editar El Camino del Hapkido
          </h2>
          <MDBBtn
            className="mugin-btn-primary"
            size="sm"
            onClick={this.saveContent}
            disabled={saving || !hasChanges}
          >
            <MDBIcon fas icon="save" className="me-2" />
            {saving ? "Guardando..." : "Guardar"}
          </MDBBtn>
        </div>

        <RichTextEditor
          initialHtml={contentHtml}
          onChangeHtml={(html) => this.setState({ contentHtml: html })}
          height={450}
          appCode="MUGIN"
        />
      </div>
    );
  }
}

export default AdminAdnSection;
